import React from 'react';
import { Grid } from '@mui/material';
import Developers from '../features/Search/components/Developers';
import GGBotChat from '../features/GGBot/GGBotChat';

const GatewayBot = () => {
  return (
      <GGBotChat />
  );
};

export default GatewayBot;
